import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import Autocomplete from '@mui/material/Autocomplete'
import { Link } from 'react-router-dom'
import { Alert, AlertTitle, Grid, TextField, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import popUpMessage from '../../config/popUpMsg.json'
import ProgressBar from '../progress/progressBar'
import { sortTranslated } from '../shared/util'
import EmployerConfig from '../../config/EmployerPopupConfig.json'

function ConfirmationDialogRaw(props) {
    const history = useHistory()
    const [popMsg] = useState(popUpMessage.newEmployer)
    const { onOk, option, open } = props
    const [value, setValue] = useState(
        props.selectedCountry
            ? {
                id: props.selectedCountry,
                name: props.selectedCountry,
                label: props.selectedCountry
            }
            : ''
    )
    const [noCountryError, setNoCountryError] = React.useState(false)
    const [noClassificationCodeError, setNoClassificationCodeError] = React.useState(false)
    const [countrySelected, setCountryselected] = useState(props.selectedCountry)
    const [allCountry, setAllCountry] = useState('')
    const [selectedClassificationCode, setSelectedClassificationCode] = useState(props.selectedClassificationCode ? props.selectedClassificationCode : null)
    const [loading, setLoading] = useState(false)
    let dropdown_vendor = []
    let new_employer_all_sources_country = []
    let findUniqueValue = []

    useEffect(() => {
        //finding out all the countries value for vendor
        option.map((filter, key) => {
            if (filter.split('#')[1] == 'IQVIA') {
                dropdown_vendor.push({
                    id: filter,
                    name: filter,
                    label: filter.split('#')[0]
                })
            }
            if (filter.split('#')[1] == 'IQVIA' || !filter.includes('#')) {
                findUniqueValue.push(filter.split('#')[0])
            }
        })
        findUniqueValue = findUniqueValue
            .filter(
                (value, index, self) => index === self.findIndex(t => t === value)
            )
            .sort((a, b) => {
                return a > b ? 1 : -1
            })

        findUniqueValue.map((filter, key) => {
            new_employer_all_sources_country.push({
                id: filter.split('#')[0],
                name: filter.split('#')[0],
                label: filter.split('#')[0]
            })
        })
        setAllCountry(new_employer_all_sources_country)
    }, [])

    // routing the pop up data to appropriate component also checking the values
    const handleOk = () => {
        if (
            selectedClassificationCode !== null &&
            selectedClassificationCode !== undefined &&
            countrySelected &&
            !noCountryError &&
            !noClassificationCodeError
        ) {
            onOk(
                {
                    country: countrySelected,
                    classificationCode: selectedClassificationCode
                }
            )
        } else {
            if (value == null || value === '') {
                setNoCountryError(
                    !(value !== null && value !== undefined && value.length > 0)
                )
            } else if (
                selectedClassificationCode == null ||
                !selectedClassificationCode.length
            ) {
                setNoClassificationCodeError(true)
            }
        }
    }

    const handleChange = (event, value, id) => {
        if (value != null && value != '') {
            if (id == 'country') {
                setCountryselected(value.id)
                setValue(value)
                setNoCountryError(false)
            } else if (id == 'ClassificationCode') {
                if (value != null && value != '') {
                    setSelectedClassificationCode(value)
                    setNoClassificationCodeError(false)
                }
            }
        } else {
            if (id == 'country' && (value == null || value == '')) {
                setSelectedClassificationCode([])
                setNoCountryError(
                    !(value !== null && value !== undefined && value.length > 0)
                )
                setValue('')
            } else if (id == 'ClassificationCode' && (value == null || value == '')) {
                setSelectedClassificationCode(null)
                setNoClassificationCodeError(
                    !(
                        selectedClassificationCode !== null &&
                        selectedClassificationCode !== undefined &&
                        selectedClassificationCode.length > 0
                    )
                )
            }
        }
    }

    const handleCancel = () => {
        props.cancel((props.selectedCountry && props.selectedClassificationCode) ? true : false)
    }

    const handleEmployerCancel = () => {
        if(props.selectedCountry && props.selectedClassificationCode) {
            props.onCancel(true)
        } else {
            // props.history.push("/")
            // route to /
            window.history.back(-1)
            return;
        }
        setValue(props.selectedCountry
            ? {
                id: props.selectedCountry,
                name: props.selectedCountry,
                label: props.selectedCountry
            }
            : '')
        setSelectedClassificationCode(props.selectedClassificationCode ? props.selectedClassificationCode : [])
    }

    return (
        <Dialog
            maxWidth={'md'}
            aria-labelledby='confirmation-dialog-title-1'
            open={open}
            keepMounted
            fullWidth
        >
            {option && option.length !== 0 && allCountry && (
                <>
                    <DialogTitle id='dialog-title'>
                        <Typography sx={{ color: "#DC3545", fontSize: "20px" }}>{`Add New ${props.entity}`}</Typography>
                        <Typography sx={{ color: "#707070", fontSize: "14px" }}> {`${popMsg[0].countryPopUp.heading} with adding a new ${props.entity} `}</Typography>
                    </DialogTitle>
                    <DialogContent dividers id='newhcp-text'>
                        <Grid
                            container
                            direction='row'
                            justifyContent='space-between'
                            flex-wrap='wrap'
                            alignItems='center'
                        >
                            <Grid item md={5.5} xs={12}>
                                <Autocomplete
                                    disableClearable
                                    value={value}
                                    key={!props.manageAccess ? 'Country' : 'Group'}
                                    options={sortTranslated(allCountry)}
                                    onChange={(event, value) => {
                                        handleChange(event, value, 'country')
                                    }}
                                    getOptionLabel={option => (option.label ? option.label : '')}
                                    isOptionEqualToValue={(optionn, value) =>
                                        optionn === value
                                    }
                                    id={!props.manageAccess ? 'Country' : 'Group'}
                                    name={!props.manageAccess ? 'Country' : 'Group'}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            error={noCountryError}
                                            label={!props.manageAccess ? 'Country' : 'Group'}
                                            variant='standard'
                                            helperText={
                                                noCountryError ? 'Please Select One Option' : ' '
                                            }
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loading ? <ProgressBar color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

{console.log(selectedClassificationCode)}
                            {(EmployerConfig.classificationCodes.length > 0) && !loading && (
                                <Grid item md={5.5} xs={12}>
                                    <Autocomplete
                                        fullWidth
                                        value={selectedClassificationCode}
                                        options={EmployerConfig.classificationCodes}
                                        onChange={(event, value) => {
                                            handleChange(event, value, 'ClassificationCode')
                                        }}
                                        getOptionLabel={option => option?.label}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        id='primary-ClassificationCode'
                                        name='primary-ClassificationCode'
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option?.id}>
                                                    {(option?.label) ? option.label : option}
                                                </li>
                                            )
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                error={noClassificationCodeError}
                                                label={'Classification Code'}
                                                variant='standard'
                                                helperText={
                                                    noClassificationCodeError ? 'Please Select One Option' : ' '
                                                }
                                            />
                                        )}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </DialogContent>
                    <DialogActions className='_wg-dynamic-text'>
                        {props.manageAccess === undefined && (
                            // <Link to='/' className='text-decoration-none custombutton' id="cancel" color="error" variant="outlined">
                            //     Cancel
                            // </Link>
                            <Button
                                onClick={handleEmployerCancel}
                                color='error'
                                variant='outlined'
                            >
                                Cancel
                            </Button>
                        )}
                        {props.manageAccess && (
                            <Button onClick={handleCancel} color='error' variant='outlined'>
                                Cancel
                            </Button>
                        )}
                        <Button onClick={handleOk} color='error' variant='contained'>
                            Confirm
                        </Button>
                    </DialogActions>
                </>
            )}

            {option && option.length == 0 && (
                <Alert severity='error' className='container' id='alert-text'>
                    <AlertTitle>You Dont have Access to Add New Employer.</AlertTitle>
                    <Link to='/'>
                        <strong className='link pointer text-primary'>back!</strong>
                    </Link>
                </Alert>
            )}
        </Dialog>
    )
}

ConfirmationDialogRaw.propTypes = {
    onOk: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    option: PropTypes.array.isRequired
}
export default ConfirmationDialogRaw
